//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../../Uk/Header";
//Install
import Footer from "../../../Uk/Footer";
//Install
import Y477FT from "../../../../../Media/Image/037.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "History : Temas Electrical Contracting"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Delivering Sustainable and Reliable Energy Solutions That Empower The Future."
        //Element
        let URL = "https://en.temaselektrik.com/history"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "History"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "From Cables To ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "The Future "
                                        ),
                                        //Element
                                        " Since 1998"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Founded in 1998 with a mission to do more than deliver electricity — to shape the future — our humble beginnings with a small team soon led to trusted projects for public institutions and small and medium-sized enterprises.",
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Every project we undertake is not merely work, but a lasting investment in the future. From 2012 onwards, we established our presence in industrial facilities and large-scale projects, pushing boundaries with modern applications and innovative solutions."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "With more than 27 years of expertise and a forward-thinking approach, we are now a respected name in the energy sector, known for projects that safely transmit energy, create value, and champion sustainability."
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "History", title: "History", src: Y477FT, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;